module.exports = __webpack_public_path__ + "media/images/mobile-only/mobile-only-1-c2b26089584f4e8bef27ad98434c140d.png";